import { IonCol, IonRow, IonText } from '@ionic/react';
import { Spinner } from '../spinner/Spinner';
import { Color } from '../common';

const ValueSpinner: React.FC = () => (
    <div style={{position: 'absolute', top: 3, left: 0}}>
        <Spinner size="xsmall" />
    </div>
);

export const LabeledValue: React.FC<{ label: string; color?: Color, value?: string; tight?: boolean, loading?: boolean }> = ({ label, color = 'dark', value = '', tight, loading }) => {
    if (!value) {
        return null;
    }
    // IonRow is always used inside IonGrid in ionic docs, but seems to work fine without it
    return (
        <IonRow style={{'--ion-grid-column-padding': '0px', alignItems: 'center'}}>
            <IonCol size={tight ? '4' : '5'} sizeSm={tight ? '2' : '3'}><IonText color="medium"><div style={{fontSize: 12, lineHeight: 1.25}}>{label}:</div></IonText></IonCol>
            <IonCol size={tight ? '8' : '7'} sizeSm={tight ? '10' : '9'}><IonText color={color}>{loading ? <ValueSpinner /> : value}</IonText></IonCol>
        </IonRow>
    );
};
